import { TradeSide, TradeStrategy } from "./index";

export enum TradeOrderStatus {
  PENDING = "pending",
  TRADING = "trading",
  PAID = "paid",
  FILLED = "filled",
  REJECTED = "rejected",
  CANCELING = "cancelling",
  CANCELLED = "cancelled",
  TIMEOUT = "timeout"
}

export type TradeOrdersParams = {
  offset?: number;
  limit?: number;
  status?: string;
  side?: TradeSide;
  strategy?: TradeStrategy;
};

export type TradeOrder = {
  amount: string;
  avg_price: string;
  base: string;
  created_at: string;
  fee: string;
  filled_amount: string;
  id: number;
  obtained_amount: string;
  extra_obtained_amount: string;
  price: string;
  quote: string;
  side: TradeSide;
  status: TradeOrderStatus;
  strategy: TradeStrategy;
  strategy_price_change: string;
  strategy_price_limit: string;
  symbol: string;
  trace_id: string;
  updated_at: string;
  user_id: string;
  base_asset: {
    asset_id: string;
    icon: string;
    symbol: string;
  };
  quote_asset: {
    asset_id: string;
    icon: string;
    symbol: string;
  };
};
